import { isNil, isString, isBoolean } from 'lodash';

// this function is used to resolve the default value of a boolean field
export const getResolvedDefaultValue = (defaultValue: unknown) => {
  // If the defaultValue is null or undefined, value as has not been set or not resolved.
  // so return the defaultValue as is.
  if (isNil(defaultValue)) {
    return defaultValue;
  }
  // If the defaultValue is a boolean, return it as is
  if (isBoolean(defaultValue)) {
    return defaultValue;
  }
  // If the defaultValue is a string, try to parse it as a boolean
  if (isString(defaultValue)) {
    return coerceStringToBoolean(defaultValue);
  }

  // If the defaultValue is not a boolean or a string, typecast it to a boolean
  return Boolean(defaultValue);
};

const coerceStringToBoolean = (value: string): boolean => {
  try {
    // parse the value
    const parsed: unknown = JSON.parse(value.trim());
    // if the parsed value is true, return true
    return parsed === true;
  } catch {
    // If the value is not a boolean, return false
    return false;
  }
};
